import { render, staticRenderFns } from "./ScrollBox.vue?vue&type=template&id=5e19b77a&scoped=true&"
import script from "./ScrollBox.vue?vue&type=script&lang=js&"
export * from "./ScrollBox.vue?vue&type=script&lang=js&"
import style0 from "./ScrollBox.vue?vue&type=style&index=0&id=5e19b77a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e19b77a",
  null
  
)

export default component.exports